import moment from 'moment';
import axios from 'src/utils/axios';
import { URLS } from 'src/utils/url';

class DashboardServiceEnergy {

	getData(params) {
		return axios.get(URLS.DASHBOARD.ALL, { params });
	}

	getGeneralData(params) {
		return axios.get(URLS.DASHBOARD.GENERAL, { params });
	}

	getDetailData(params) {
		return axios.get(URLS.DASHBOARD.DETAIL, { params });
	}

	getDateRange(dateOption) {
		switch(dateOption) {
			case 'today': 
				return {
					startDate: moment().startOf('day').toDate(),
					endDate: moment().endOf('day').toDate()
				}
			case 'yesterday': 
				return {
					startDate: moment().subtract(1, 'day').startOf('day').toDate(),
					endDate: moment().subtract(1, 'day').endOf('day').toDate()
				}
			case 'week': 
				return {
					startDate: moment().startOf('week').toDate(),
					endDate: moment().endOf('day').toDate()
				}
			case 'month': 
				return {
					startDate: moment().startOf('month').toDate(),
					endDate: moment().endOf('day').toDate()
				}
			case 'year': 
				return {
					startDate: moment().startOf('year').toDate(),
					endDate: moment().endOf('day').toDate()
				}
	}
	}
}

export const dashboardServiceEnergy = new DashboardServiceEnergy();
